<template>
  <div class="d-flex align-items-center min-vh-100">
    <CContainer fluid>
      <CRow class="justify-content-center">
        <CCol md="6">
          <CCardGroup>
            <CCard class="mb-0">
              <CCardBody class="p-4">
                <CForm>
                  <h1>Register Company</h1>
                  <p class="text-muted">Create your company</p>
                  <CRow>
                    <CCol class="col-md-6">
                      <CInput
                          placeholder="Company Name"
                          autocomplete="company_name"
                          v-model="form.company_name"
                          name="company_name"
                          v-validate="{required: true, min: 3}"
                      >
                        <template #prepend-content><building fillColor="#009FE3" :size=Number(17) /></template>
                      </CInput>
                      <div v-if="errors" class="error_msg">
                        {{errors.first('company_name')}}
                      </div>
                    </CCol>
                    <CCol class="col-md-6 form-group">
                      <v-select autocomplete="off" :options="countries" name="country" v-validate="{required: true}"
                       v-model="form.country_id" :reduce="country => country.id" placeholder="Select Country" :clearable="false"/>
                      <div v-if="errors" class="error_msg">
                        {{errors.first('country')}}
                      </div>
                    </CCol>
                    <CCol class="col-md-6">
                      <CInput
                          placeholder="Name"
                          autocomplete="name"
                          v-model="form.name"
                          name="name"
                          v-validate="{required: true}"
                      >
                        <template #prepend-content><account fillColor="#009FE3" :size=Number(17) /></template>
                      </CInput>
                      <div v-if="errors" class="error_msg">
                        {{errors.first('name')}}
                      </div>
                    </CCol>
                    <CCol class="col-md-6">
                      <CInput
                          placeholder="Email"
                          autocomplete="email"
                          v-model="form.email"
                          name="email"
                          v-validate="{required: true, email: true}"
                      >
                        <template #prepend-content><email fillColor="#009FE3" :size=Number(17) /></template>
                      </CInput>
                      <div v-if="errors" class="error_msg">
                        {{errors.first('email')}}
                      </div>
                    </CCol>
                    <CCol class="col-md-6">
                      <CInput
                          placeholder="Password"
                          type="password"
                          autocomplete="new-password"
                          v-model="form.password"
                          name="password"
                          v-validate="{required: true, min: 3}"
                          ref="password"
                      >
                        <template #prepend-content><lock fillColor="#009FE3" :size=Number(17) /></template>
                      </CInput>
                      <div v-if="errors" class="error_msg">
                        {{errors.first('password')}}
                      </div>
                    </CCol>
                    <CCol class="col-md-6">
                      <CInput
                          placeholder="Confirm password"
                          type="password"
                          autocomplete="new-password"
                          v-model="form.password_confirmation"
                          name="password_confirmation"
                          v-validate="'required|confirmed:password'"
                          data-vv-as="password"
                      >
                        <template #prepend-content><lock fillColor="#009FE3" :size=Number(17) /></template>
                      </CInput>
                      <div v-if="errors" class="error_msg">
                        {{errors.first('password_confirmation')}}
                      </div>
                    </CCol>
                    <CCol class="col-md-6">
                        <CInput
                            placeholder="Company Url"
                            v-model="form.company_domain"
                            name="company_url"
                            v-validate="{required: true, url: {require_protocol: false }}" data-vv-as="company domain"
                        >
                          <template #prepend-content><email-edit-outline fillColor="#009FE3" :size=Number(17) /></template>
                        </CInput>
                        <div v-if="errors" class="error_msg">
                          {{errors.first(`company_url`)}}
                        </div>
                        <CInput
                            class="d-none"
                            placeholder="Company Url Subpage"
                            v-model="form.subpage_url"
                            name="subpage_url"
                        >
                          <template #prepend-content><lock fillColor="#009FE3" :size=Number(17) /></template>
                        </CInput>

                    </CCol>
                    <CCol class="col-md-12 mt-5">
                      <div
                        class="fixed-logo-dropzone"
                        :class="{ 'has-error': errors.has('file') }"
                        @dragover.prevent
                        @dragenter.prevent
                        @drop.prevent="handleDrop"
                        @click="triggerFilePicker"
                      >
                        <input
                          type="file"
                          ref="fixedLogoInput"
                          class="d-none"
                          name="file"
                          accept=".svg,image/svg+xml"
                          @change="handleFixedLogo"
                        />

                        <div v-if="!fixedLogoPreview" class="dropzone-placeholder">
                          <p class="mb-1">Drag & drop your Fixed logo SVG  here</p>
                          <small>or click to browse (.svg)</small>
                        </div>

                        <div v-else class="preview-wrapper">
                          <!-- SVG preview -->
                          <img :src="fixedLogoPreview" alt="Fixed Logo SVG" />

                          <button
                            type="button"
                            class="remove-btn"
                            @click.stop="removeFixedLogo"
                          >
                            ✕
                          </button>
                        </div>
                      </div>

                      <div v-if="errors.has('file')" class="error_msg mt-1">
                        {{ errors.first('file') }}
                      </div>
                    </CCol>


                  </CRow>

                  <CButton color="success" class="mt-3" block @click="registerUser">Create Account</CButton>
                  <div  class="d-lg-none">
                    <p class="text-center mt-2 mb-1"><strong>OR</strong></p>
                    <router-link to="/login">
                      <CButton color="primary" block>Login</CButton>
                    </router-link>
                  </div>
                </CForm>
              </CCardBody>
              <CCardFooter class="p-4">
                <CRow>
                  <CCol col="12 text-center">
                    <CButton
                        class="w-50"
                        to="/Login"
                        color="twitter"
                    >
                      Login Now!
                    </CButton>

                  </CCol>
                </CRow>
              </CCardFooter>
            </CCard>
          </CCardGroup>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>

<script>
import Building from 'vue-material-design-icons/OfficeBuildingMarkerOutline.vue';
import EmailEditOutline from 'vue-material-design-icons/EmailEditOutline.vue';
import Account from 'vue-material-design-icons/Account.vue';
import Email from 'vue-material-design-icons/Email.vue';
import Lock from 'vue-material-design-icons/Lock.vue';
import vSelect from "vue-select";
import myMixins from '@/mixins/myMixins';
import { http } from '@/config/httpCommon';
export default {
  mixins: [myMixins],
  components:{
    Building,
    EmailEditOutline,
    Account,
    Email,
    Lock,
    vSelect,
  },
  name: 'Register',
  data(){
    return {
      form:{
        company_name: '',
        country_id: '',
        name: '',
        email: '',
        password: '',
        password_confirmation: '',
        company_domain: '',
        file: null,
      },
      fixedLogoPreview: null, 
      countries: [],
      prev_route: null
    }
  },
  async created() {
    try {
      this.$store.commit('set', ['showLoader', true]);
      await this.$store.dispatch('countries');
      this.countries = this.$store.getters.getCountries;
      this.$store.commit('set', ['showLoader', false]);
    }catch (err){
      this.$store.commit('set', ['showLoader', false]);
      this.handleResponseErrors(err);
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.prev_route = from
    })
  },
  methods:{
    handleFixedLogo(e) {
    const file = e.target.files[0];
    this.setFixedLogo(file);
  },

  handleDrop(e) {
    const file = e.dataTransfer.files[0];
    this.setFixedLogo(file);
  },

  setFixedLogo(file) {
    if (!file) return;

    // STRICT SVG CHECK
    const isSvg =
      file.type === 'image/svg+xml' ||
      file.name.toLowerCase().endsWith('.svg');

    if (!isSvg) {
      this.showToast('Only SVG files are allowed', 'error');
      this.removeFixedLogo();
      return;
    }

    this.form.file = file;
    this.fixedLogoPreview = URL.createObjectURL(file);
  },

  triggerFilePicker() {
    this.$refs.fixedLogoInput.click();
  },

  removeFixedLogo() {
    this.form.file = null;
    this.fixedLogoPreview = null;
    this.$refs.fixedLogoInput.value = null;
  },

  registerUser() {
    this.$validator.validate().then(validated => {
      if (!validated) return;

      this.$store.commit('set', ['showLoader', true]);

      const formData = new FormData();
      Object.keys(this.form).forEach(key => {
        if (this.form[key] !== null) {
          formData.append(key, this.form[key]);
        }
      });

      http.post('company', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })
      .then(() => {
        this.$store.commit('set', ['showLoader', false]);
        this.showToast('Your account is created successfully', 'SUCCESS');
        this.$router.push(this.prev_route?.name === 'companies' ? 'companies' : 'login');
      })
      .catch(err => {
        this.$store.commit('set', ['showLoader', false]);
        this.handleResponseErrors(err);
      });
    });
  }
},
    
}
</script>
<style scoped lang="scss">
.error_msg{
  color: brown;
}
.form-group {
  margin: 1rem 0 0 0;
}
.additional-fields{
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-end;
  .form-group{
    max-width: 90%;
    flex: 0 0 90%;
  }
  .btn{
    background: none;
    padding: 0;
    color: red;
    border: none;
    margin-bottom: 5px;
  }
}
.btn-add-fields{
  display: block;
  width: 100%;
  background: none;
  border: 1px solid #4f5d73;
  font-size: 0.75rem;
  margin-top: 1rem;
  padding: 0.4rem;
  line-height: 1;
  transition: all 0.3s ease;
  &:hover{
    background: #2EA169;
    color: #fff;
    border-color: #fff;
  }
}



.fixed-logo-dropzone {
  border: 2px dashed #009FE3;
  border-radius: 8px;
  padding: 30px;
  text-align: center;
  cursor: pointer;
  transition: 0.3s ease;
  background: #f9fcff;
  position: relative;

  &:hover {
    background: #eef7fd;
  }

  &.has-error {
    border-color: brown;
  }
}

.dropzone-placeholder {
  color: #555;

  strong {
    font-size: 1.1rem;
    color: #009FE3;
  }
}

.preview-wrapper {
  position: relative;
  display: inline-block;

  img {
    max-height: 120px;
    max-width: 100%;
    border-radius: 6px;
    border: 1px solid #ddd;
    padding: 5px;
    background: #fff;
  }

  .remove-btn {
    position: absolute;
    top: -10px;
    right: -10px;
    background: #c80000;
    color: #fff;
    border: none;
    border-radius: 50%;
    width: 26px;
    height: 26px;
    cursor: pointer;
    font-weight: bold;
  }
}

</style>
